// extracted by mini-css-extract-plugin
export default {"momentumGrid":"momentumGrid","statBox":"statBox","statValue":"statValue","statLabel":"statLabel"};